<template>
  <el-container>
    <el-header>
      <home-header></home-header>
    </el-header>
    <el-container v-if="isShow">
      <home-side></home-side>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import HomeHeader from '@/common/components/head/HomeHeader'
import HomeSide from '@/common/components/side/HomeSide'

export default {
  name: "index",
  data() {
    return {
      width: '',
      isShow: true,
    }
  },
  components: {HomeHeader, HomeSide},
}
</script>

<style lang="scss" scoped>
/* 让主内容区成为唯一纵向滚动容器，避免 #app / body / el-main 叠出多重滚动条 */
.el-container {
  height: 100%;
  min-height: 0;
}

.el-header {
  height: 50px !important;
  padding: 0;
  flex-shrink: 0;
}

.el-container > .el-container {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.el-main {
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 15px;
  background-color: #f3f4f6;
}
</style>
